import axiosInstance from './axios';

export const createOrder = async (orderData) => {
  const response = await axiosInstance.post('/orders', orderData);
  // Handle the response structure
  if (response.data && response.data.success) {
    return response.data;
  }
  return response.data;
};
